import React from 'react';
import { Button, Modal, Row, Typography } from 'components';
import { RemoveIconBig } from 'components/common/icons';
import { Col } from 'antd';
import { useSupplierRemoveModal } from 'feature/brandTabs/pricingAndSuppliers/supplierGrid/supplierRemoveModal/useSupplierRemoveModal';

const { Title, Text } = Typography;

interface ISupplierRemoveModel {
  modalState: boolean;
  onModalStateChange: () => void;
  supplierId: string | null;
}

export const SupplierRemoveModel = React.memo((props: ISupplierRemoveModel) => {
  const { modalState, onModalStateChange, supplierId } = props;
  const { handleCancel, handleSubmit, contextHolder, isLoading } = useSupplierRemoveModal({
    onModalStateChange,
    supplierId,
  });
  return (
    <>
      {contextHolder}
      <Modal
        open={modalState}
        onOk={handleSubmit}
        onCancel={handleCancel}
        closable={false}
        width={360}
        centered
        footer={() => (
          <Row wrap={false} className={'gap-8'} style={{ marginTop: '24px' }}>
            <Button block size={'large'} onClick={handleCancel}>
              Cancel
            </Button>
            <Button loading={isLoading} block size={'large'} type="primary" onClick={handleSubmit}>
              Remove
            </Button>
          </Row>
        )}
      >
        <Row align={'middle'} gutter={[0, 12]} justify={'center'}>
          <RemoveIconBig />
          <Col span={24}>
            <Title style={{ color: '#222530', textAlign: 'center', margin: 0, padding: 0 }} level={3}>
              Remove Supplier
            </Title>
          </Col>
          <Text className={'center'}>Are you sure you want to remove this supplier from the list?</Text>
        </Row>
      </Modal>
    </>
  );
});
